<template>
  <div>
    <vue-headful
    :title="propsdata[0]['translation']['account-head-title']"
    :description="propsdata[0]['translation']['account-head-description']"
/>

    <div v-if="loading" style="margin-top: 150px;">
      <lottie-player src="https://qr.io/lottie/qr-loading.json" background="transparent" speed="1" style="width: 230px; height: 230px; margin: 0 auto;" loop autoplay></lottie-player>
    </div>

    <div v-if="!loading" class="container mb-3">
      <div class="card border-light shadow-soft rounded-top-0 rounded-bottom">
        <div class="card-body p-4">
          <div>
            <div class="col-12 p-0">
              <div class="form-group">
                <label class="form-label text-dark">{{propsdata[0]['translation']['account-name']}}</label>
                <div class="input-group mb-2">
                  <div class="input-group-prepend">
                    <span class="input-group-text"><i class="fas fa-user-alt"></i></span>
                  </div>
                  <input v-model="propsdata[0].name" name="name" class="form-control pl-2" placeholder="eg. John Doe" type="text">
                </div>
                <button v-if="!saving" @click="guardarname" style="width: 100%;" class="btn btn-secondary animate-up-2"><span class="mr-2"><i class="fas fa-paper-plane"></i></span>{{propsdata[0]['translation']['account-button-save-name']}}</button>
                <button v-if="saving" style="width: 100%;background:#04a677!important;border-color:#04a677!important;" class="btn btn-primary animate-up-2"><span class="mr-2"><i class="fas fa-check"></i></span>{{propsdata[0]['translation']['account-button-saved-name']}}</button>
              </div>
            </div>
            <hr>
            <div class="col-12 p-0">
              <div v-if="propsdata[0].team_member !== 'yes'" class="form-group">
                <label class="form-label text-dark">{{propsdata[0]['translation']['account-email']}}</label>
                <div class="input-group mb-2">
                  <div class="input-group-prepend">
                    <span class="input-group-text"><i class="fas fa-envelope"></i></span>
                  </div>
                  <input :value="propsdata[0].email" name="name" class="form-control pl-2" type="text" disabled>
                </div>
                <h6 v-if="verify_changed_email" style="color: #0fab7b;" class="mb-2">{{propsdata[0]['translation']['account-email-verify']}} {{new_email}}.</h6>
                <!-- change email -->
                <div v-if="changeemail_toggle" class="mb-2">
                  <div class="input-group mb-2">
                    <div class="input-group-prepend"><span class="input-group-text"><i class="fas fa-envelope"></i></span></div>
                    <input v-model="new_email" name="email" :placeholder="propsdata[0]['translation']['account-email-placeholder']" type="email" class="form-control pl-2">
                  </div>
                  <span v-if="unknown_error_email" class="small" style="color:#ff0000;">{{propsdata[0]['translation']['account-email-unknown-error-email']}}</span>
                  <span v-if="invalidemail" class="small" style="color:#ff0000;">{{propsdata[0]['translation']['account-email-invalid-format']}}</span>
                  <span v-if="new_emailtaken" class="small" style="color:#ff0000;">{{propsdata[0]['translation']['account-email-used']}}</span>
                  <button v-if="!changingemail" @click="guardaremail" style="width: 100%;" class="btn btn-secondary animate-up-2"><span class="mr-2"><i class="fas fa-paper-plane"></i></span>{{propsdata[0]['translation']['account-button-change-email']}}</button>
                  <button v-if="changingemail" style="width: 100%;background:#04a677!important;border-color:#04a677!important;" class="btn btn-secondary animate-up-2"><span class="mr-2"><i class="fas fa-check"></i></span>{{propsdata[0]['translation']['account-button-change-email-loading']}}</button>
                  <button v-if="changeemail_toggle" @click="cancel_changeemail" style="width: 100%;background:#fa5352!important;border-color:#fa5352!important;margin-top:10px;" class="btn btn-danger animate-up-2"><span class="mr-2"><i class="fas fa-times"></i></span>{{propsdata[0]['translation']['account-button-change-email-cancel']}}</button>
                </div>
                <div v-else class="mb-2">
                  <button @click="changeemail" style="width: 100%;" class="btn btn-secondary animate-up-2"><span class="mr-2"><i class="fas fa-pen"></i></span>{{propsdata[0]['translation']['account-button-change-email-toggle']}}</button>
                </div>
                <p>{{propsdata[0]['translation']['account-email-instructions']}}</p>
              </div>
              <div v-else class="form-group">
                <label class="form-label text-dark">{{propsdata[0]['translation']['account-email-team-member-cant-change-1']}} (<span class="small">{{propsdata[0]['translation']['account-email-team-member-cant-change-2']}}</span>)</label>
                <div class="input-group mb-2">
                  <div class="input-group-prepend">
                    <span class="input-group-text"><i class="fas fa-envelope"></i></span>
                  </div>
                  <input :value="propsdata[0].email" name="name" class="form-control pl-2" type="text" disabled>
                </div>
              </div>
            </div>
            <hr>
            <div class="col-12 p-0">
              <div class="form-group">
                <label class="form-label text-dark">{{propsdata[0]['translation']['account-choose-language']}}</label>
                <select v-model='language' class="custom-select mb-2" id="selectlanguages">
                <option value='en'>{{propsdata[0]['translation']['account-english']}}</option>
                <option value='es'>{{propsdata[0]['translation']['account-spanish']}}</option>
                <option value='pt'>{{propsdata[0]['translation']['account-portuguese']}}</option>
                <option value='it'>{{propsdata[0]['translation']['account-italian']}}</option>
                <option value='fr'>{{propsdata[0]['translation']['account-french']}}</option>
                <option value='de'>{{propsdata[0]['translation']['account-german']}}</option>
                </select>
                <button v-if="!savinglanguage" @click="changelanguage" style="width: 100%;" class="btn btn-secondary animate-up-2">{{propsdata[0]['translation']['account-button-save-language']}}</button>
                <button v-if="savinglanguage" style="width: 100%;" class="btn btn-secondary animate-up-2">{{propsdata[0]['translation']['account-button-saving-language']}}</button>
              </div>
            </div>
            <hr>
            <div class="col-12 p-0">
              <div class="form-group">
                <label class="form-label text-dark">{{propsdata[0]['translation']['account-password']}}</label>
                <div v-if="propsdata[0].password !== 'submitted' || changepassword_toggle">
                  <div class="input-group mb-2">
                    <div class="input-group-prepend"><span class="input-group-text"><i class="fas fa-lock"></i></span></div>
                    <input v-model="password" name="password" :placeholder="propsdata[0]['translation']['account-password-placeholder']" type="password" class="form-control pl-2">
                  </div>
                  <span v-if="shortpassword" class="small mb-2" style="color:#ff0000;">{{propsdata[0]['translation']['account-password-short']}}</span>
                  <span v-if="unknown_error_password" class="small mb-2" style="color:#ff0000;">{{propsdata[0]['translation']['account-password-unknown-error']}}</span>
                  <button v-if="!savingpassword" @click="guardarpassword" style="width: 100%;" class="btn btn-secondary animate-up-2"><span class="mr-2"><i class="fas fa-paper-plane"></i></span>{{propsdata[0]['translation']['account-button-save-password']}}</button>
                  <button v-if="savingpassword" style="width: 100%;background:#04a677!important;border-color:#04a677!important;" class="btn btn-secondary animate-up-2"><span class="mr-2"><i class="fas fa-check"></i></span>{{propsdata[0]['translation']['account-button-saving-password']}}</button>
                  <button v-if="changepassword_toggle" @click="cancel_changepassword" style="width: 100%;background:#fa5352!important;border-color:#fa5352!important;margin-top:10px;" class="btn btn-danger animate-up-2"><span class="mr-2"><i class="fas fa-times"></i></span>{{propsdata[0]['translation']['account-button-cancel-password']}}</button>
                </div>
                <div v-else>
                  <button @click="changepassword" style="width: 100%;" class="btn btn-secondary animate-up-2"><span class="mr-2"><i class="fas fa-pen"></i></span>{{propsdata[0]['translation']['account-button-change-password-toggle']}}</button>
                </div>
              </div>
            </div>
            <div v-if="propsdata[0].paid !== 'yes' || propsdata[0].team_member === 'yes'">
              <a v-if="!moreinformation" @click="moreinformation = true" style="text-decoration:underline;" class="col-12 p-0">{{propsdata[0]['translation']['account-more-info']}} <i class="fas fa-caret-down"></i></a>
              <a v-if="moreinformation" @click="moreinformation = false" style="text-decoration:underline;" class="col-12 p-0">{{propsdata[0]['translation']['account-less-info']}} <i class="fas fa-caret-up"></i></a>
              <div v-if="moreinformation">
                <hr>
                <div class="col-12 p-0">
                  <div class="form-group mb-0">
                    <label class="form-label text-dark">{{propsdata[0]['translation']['account-delete-account']}}</label>
                    <p v-if="propsdata[0].team_member !== 'yes'">{{propsdata[0]['translation']['account-delete-warning-owner']}}</p>
                    <p v-else>{{propsdata[0]['translation']['account-delete-warning-team-member']}}</p>
                    <a @click="open_modal_delete_account" style="text-decoration:underline;">{{propsdata[0]['translation']['account-delete-button']}}</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <br><br>
      <div v-show="propsdata[0].freetrial === 'yes' && propsdata[0].cargado" style="display:none;" class="card border-light shadow-soft mb-4">
        <div>
          <div class="card-body p-4">
            <div class="text-center">
              <div>
                <h3 class="mb-3">{{propsdata[0]['translation']['account-upgrade-account']}}</h3>
                <p class="text-muted mb-4">{{propsdata[0]['translation']['account-upgrade-account-description']}}</p>
              </div>
              <div>
                <a :href="'/choose-plan/'+propsdata[0].unique_id+'?utm_campaign=dashboard_on_trial'" class="btn btn-md btn-pricing-plan animate-up-2" style="color: #ffffff; background-color: #0949b3; border-color: rgb(255, 255, 255);"><svg width="24" height="24" fill="#ffffff" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" class="sc-eNQAEJ bqIowC"><path d="M5 12.5H15V14H5V12.5Z M5 11L4 7L8 8L10 4L12 8L16 7L15 11H5Z"></path></svg>{{propsdata[0]['translation']['account-upgrade-account-button']}}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-show="propsdata[0].paid !== 'yes' && propsdata[0].freetrial !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes' && propsdata[0].cargado" style="display:none;" class="card border-light shadow-soft mb-4">
        <div>
          <div class="card-body p-4">
            <div class="text-center">
              <div>
                <h3 class="mb-3">{{propsdata[0]['translation']['account-upgrade-account']}}</h3>
                <p class="text-muted mb-4">{{propsdata[0]['translation']['account-upgrade-account-description']}}</p>
              </div>
              <div>
                <a :href="'/choose-plan/'+propsdata[0].unique_id+'?utm_campaign=dashboard_trial_expired'" class="btn btn-md btn-pricing-plan animate-up-2" style="color: #ffffff; background-color: #0949b3; border-color: rgb(255, 255, 255);"><svg width="24" height="24" fill="#ffffff" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" class="sc-eNQAEJ bqIowC"><path d="M5 12.5H15V14H5V12.5Z M5 11L4 7L8 8L10 4L12 8L16 7L15 11H5Z"></path></svg>{{propsdata[0]['translation']['account-upgrade-account-button']}}</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Delete Account Modal Content -->
      <div v-if="modal_delete_account" @click="close_modal_delete_account" class="modal" style="display: block !important; background: rgba(147, 152, 165, 0.35); overflow: auto;">
        <div @click.stop class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h6 class="modal-title">{{propsdata[0]['translation']['account-modal-delete-question']}}</h6>
              <button @click="close_modal_delete_account" class="close">
                <span>&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <p style="margin: 0;">{{propsdata[0]['translation']['account-modal-delete-description']}}</p>
            </div>
            <div class="modal-footer">
              <a href="https://qr.io/dashboard/delete-account" class="btn btn-sm btn-success">{{propsdata[0]['translation']['account-modal-delete-yes']}}</a>
              <button @click="close_modal_delete_account" class="btn btn-link text-danger ml-auto">{{propsdata[0]['translation']['account-modal-delete-close']}}</button>
            </div>
          </div>
        </div>
      </div>
      <!-- End of Delete Account Modal Content -->

    </div>
  </div>
</template>

<script>
  export default {
    props:['propsdata'],
    data() {
      return {
        loading: true,
        saving: false,
        changeemail_toggle: false,
        new_email: '',
        changingemail: false,
        unknown_error_email: false,
        invalidemail: false,
        new_emailtaken: false,
        verify_changed_email: false,
        changepassword_toggle: false,
        password: '',
        savingpassword: false,
        unknown_error_password: false,
        shortpassword: false,
        moreinformation: false,
        language: '',
        savinglanguage: false,
        modal_delete_account: false
      };
    },
    methods: {
      guardarname(){
        this.saving = true;
        axios.post('/dashboard/edit-name.php', {
          name: this.propsdata[0].name
        })
        .then(response => {
          this.saving = false;
        })
        .catch(function (error) {
          console.log(error);
        });
      },
      guardaremail(){
        this.changingemail = true;
        this.unknown_error_email = false;
        this.invalidemail = false;
        this.new_emailtaken = false;
        this.verify_changed_email = false;
        axios.post('/dashboard/change-email.php', {
          new_email: this.new_email
        })
        .then(response => {
          if(response.data == 'There was an error'){
            this.unknown_error_email = true;
          }
          else if(response.data == 'Invalid Email'){
            this.invalidemail = true;
          }
          else if(response.data == 'Email Taken'){
            this.new_emailtaken = true;
          }
          else{
            this.verify_changed_email = true;
            this.changeemail_toggle = false;
          }
          this.changingemail = false;
        })
        .catch(function (error) {
          console.log(error);
        });
      },
      changeemail(){
        this.changeemail_toggle = true;
        this.verify_changed_email = false;
      },
      cancel_changeemail(){
        this.changeemail_toggle = false;
        this.unknown_error_email = false;
        this.invalidemail = false;
        this.new_emailtaken = false;
        this.verify_changed_email = false;
        this.new_email = '';
      },
      changelanguage(){
        this.savinglanguage = true;
        axios.post('/dashboard/change-language.php', {
          language: this.language
        })
        .then(response => {
          window.location.href = 'https://qr.io/dashboard/account';
        })
        .catch(function (error) {
          console.log(error);
        });
      },
      guardarpassword(){
        this.savingpassword = true;
        this.shortpassword = false;
        this.unknown_error_password = false;
        axios.post('/dashboard/edit-password.php', {
          password: this.password
        })
        .then(response => {
          if(response.data == 'There was an error while updating the password'){
            this.unknown_error_password = true;
          }
          else if(response.data == 'Password must be at least 6 characters'){
            this.shortpassword = true;
          }
          else if(response.data == 'Password updated successfully'){
            this.propsdata[0].password = 'submitted';
            this.password = '';
            this.changepassword_toggle = false;
          }
          this.savingpassword = false;
        })
        .catch(function (error) {
          console.log(error);
        });
      },
      changepassword(){
        this.changepassword_toggle = true;
      },
      cancel_changepassword(){
        this.changepassword_toggle = false;
      },
      open_modal_delete_account(){
        this.modal_delete_account = true;
      },
      close_modal_delete_account(){
        this.modal_delete_account = false;
      }
    },
    mounted() {
      this.$emit('updatepath');
      this.loading = false;
      this.language = this.propsdata[0].language;
    }
  };
</script>



// WEBPACK FOOTER //
// src/account.vue